import React, { useState } from "react";
import { ControlsRow } from "../base/ControlsRow";
import { ImportantButton } from "../base/ImportantButton";
import { SecondaryButton } from "../base/SecondaryButton";
import { TextInput } from "../base/TextInput";
import { PanelTextInput } from "../base/PanelTextInput";
import { useExtendedMutation } from "mutations";
import { addPrivateCategory } from "api";
import { useAccountStats } from "context";
import "./AddCategoryControls.css";

const AddCategoryControls = ({ token, onBack, onSaved, onLoadingChange, variant = 'default' }) => {
  const Btn = variant === 'secondary' ? SecondaryButton : ImportantButton;
  const Txt = variant === 'secondary' ? PanelTextInput : TextInput;
  const { incrementCategoryCount } = useAccountStats();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [subcategoryTitle, setSubcategoryTitle] = useState('');
  const [subcategoryDescription, setSubcategoryDescription] = useState('');

  const errorCallback = (error) => {
    console.log(error);
    onLoadingChange?.(false);
  };

  const addCategoryMutation = useExtendedMutation(
    addPrivateCategory,
    () => {
      setTitle('');
      setDescription('');
      setSubcategoryTitle('');
      setSubcategoryDescription('');
      incrementCategoryCount();
      onLoadingChange?.(false);
      onSaved();
    },
    errorCallback
  );

  const handleSave = () => {
    if (title.trim()) {
      onLoadingChange?.(true);
      addCategoryMutation.mutateOnVirtualThread({ token, title, description, subcategoryTitle, subcategoryDescription });
    }
  };

  return (
    <div className="add-category-controls">
      <ControlsRow horizontalOnMobile={true}>
        <Txt
          value={title}
          callbackOnChange={(e) => setTitle(e.target.value)}
          placeholder={"Category title"}
          maxLength={50}
        />
        <Txt
          value={description}
          callbackOnChange={(e) => setDescription(e.target.value)}
          placeholder={"Category description"}
          maxLength={100}
        />
      </ControlsRow>
      <ControlsRow horizontalOnMobile={true}>
        <Txt
          value={subcategoryTitle}
          callbackOnChange={(e) => setSubcategoryTitle(e.target.value)}
          placeholder={"Subcategory title"}
          maxLength={50}
        />
        <Txt
          value={subcategoryDescription}
          callbackOnChange={(e) => setSubcategoryDescription(e.target.value)}
          placeholder={"Subcategory description"}
          maxLength={100}
        />
      </ControlsRow>
      <ControlsRow horizontalOnMobile={true}>
        <Btn buttonText={"Back"} onClick={onBack} />
        <Btn buttonText={"Add"} onClick={handleSave} />
      </ControlsRow>
    </div>
  );
};

export { AddCategoryControls };
